module.exports = new function flickity()
{

    $(document).ready(function () {

        $('.single-slider').show();

        const Flickity = require('flickity');
        const singleSlider = document.querySelector('.single-slider');

        if ( singleSlider && document.querySelectorAll('.slot-cell').length > 1 ) {

            let flkty = new Flickity( singleSlider, {
                cellSelector: '.slot-cell',
                cellAlign: 'center',
                autoPlay: 5000,
                initialIndex: 1,
                wrapAround: true,
                lazyLoad: 3
            });

        }
    })

}
